
import React from 'react';
import MaterialOption from './materialOption';
import { isNumber } from 'util';
import { contentRoot } from '../config.js';
let getSelectionName = (selected,materials)=>
{
  let r = materials.filter((m)=>{
    return m.id===selected;
  });
    if(r[0])
    {
        return r[0].name;
    }
};
let selectionHeader = (selected, materials, show) => {
    if (show)
        return <span><h3>{getSelectionName(selected, materials)}</h3></span>;
    else
        return  "";
};



let getSelectionPrice = (selected, prices) => {
    let r = prices && prices[selected];
    if (isNumber(r)) {
        return r.toFixed(2) +" €";
    }
    
};

let spacing = 2;
const materialSelect = ({ materials, prices, showPrices, header, headerIcon, onChange, selected, autoAdjustWidth, onInfoClick, columnNum, mirrored, hideHeader }) => {
    let itemWidth = 0
    if (autoAdjustWidth && materials.length > 0) {
        let columns = columnNum || materials.length;
        itemWidth = Math.floor(100 / columns) - spacing;
        if (!columnNum) {
            itemWidth = Math.max(11, itemWidth);
            itemWidth = Math.min(31, itemWidth);
        }
        itemWidth -= 0.5;
    }
    if (materials.length > 0)
  {        
      return (<div className="materialSelect clearfix">
          {(showPrices && selected) ? <div>Muutoksen vaikutus hintaan: {getSelectionPrice(selected, prices)}</div> : ""}
          <div className={"materialSelectHeading" + (headerIcon ? " hasIcon" : "")}>
              {headerIcon ? <span className="materialSelectHeadingIcon" aria-hidden="true">{headerIcon}</span> : ""}
              <div className="materialSelectHeadingText">
                  <span><h2 style={{ display: "inline", marginRight: "0.5em" }}>{header}</h2>
                      {onInfoClick ? (<span style={{ cursor: "pointer" }} onClick={onInfoClick}><img src={contentRoot + "img/ohje.png"} alt ="instructions"></img></span>) : ""}</span>
                  {selectionHeader(selected, materials, !hideHeader)}
              </div>
          </div>
          <div className="materialRow">
          {materials.map(material => <MaterialOption mirrored={mirrored} key={material.id} material={material} selected={selected} onChange={onChange} itemWidth={itemWidth} />)} 
          </div>
    </div>);
  }
else
  {
    return (<h1>Ei valintoja</h1>);
  }
}
export default materialSelect
